import { Button, Container, Text, Title } from "@mantine/core";
import { useSelector } from "react-redux";

import PageLayout from "../Styles/PageLayout";
import PageContent from "../Styles/PageContent";

const ErrorPage = ({ showBackButton = true }) => {
  const { language } = useSelector((state) => ({
    language: state.language,
  }));

  return (
    <PageLayout>
      <PageContent>
        <Container
          style={{
            textAlign: "center",
            margin: "3rem 0",
            maxWidth: "100%",
            padding: 0,
          }}
        >
          <Title mb="lg" order={1}>
            {language.ErrorPage?.SomethingWentWrong || "Something went wrong"}
          </Title>
          {language.ErrorPage.ShopLoadError && (
            <Text component="p" mb="lg">
              {language.ErrorPage.ShopLoadError}
            </Text>
          )}
          {showBackButton && (
            <Button
              component="a"
              onClick={() => (window.location.href = "/ticketshop")}
              className="mantine-Primary-btn backButton"
              variant="filled"
              size="md"
              radius="sm"
              color="indigo"
            >
              {language.BackToHomepage || "Back to Homepage"}
            </Button>
          )}
        </Container>
      </PageContent>
    </PageLayout>
  );
};

export default ErrorPage;
